import { Box } from 'components/Box/Box';
import { BodyLarge } from 'components/Text/BodyLarge';
import { BodySmall } from 'components/Text/BodySmall';
import type {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockBlockquote,
} from 'modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import { colors, gutterWidth } from 'theme/theme';

import { CmsSplitContentBlockquote } from './CmsSplitContentBlockquote';

type Props = {
  appearance: CmsApiSplitBlockAppearance;
  blockId: string;
  section: CmsApiSplitBlockBlockquote;
  blockIndex: number;
  index: number;
};

export function CmsSplitContentBlockquoteContent({
  appearance,
  blockId,
  blockIndex,
  index,
  section,
}: Props) {
  const showTextBox = ['FULL_WIDTH', 'OVERLAPPING'].includes(appearance);
  return (
    <Box
      data-qa-id={`split-content-section-${index}`}
      // @ts-expect-error TS(2322): Type 'false | 1' is not assignable to type 'Respon... Remove this comment to see the full error message
      zIndex={showTextBox && 1}
      width={[1, null, 1 / 2]}
      px={[gutterWidth / 4, null, gutterWidth / 2]}
      py={[gutterWidth / 4, null, gutterWidth / 2]}
      key={blockId}
    >
      <Box
        left={[null, null, '50%']}
        top={[null, null, '50%']}
        height="100%"
        width="100%"
        bg={showTextBox ? 'white' : colors.backgroundGrey}
        boxShadow={showTextBox ? '0 0 6px rgba(0,0,0,0.3)' : null}
        borderRadius={showTextBox ? 12 : 24}
      >
        <CmsSplitContentBlockquote
          component="blockquote"
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          height="100%"
          m={0}
          p={[gutterWidth / 2, null, gutterWidth]}
        >
          <BodyLarge
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Split Content',
              },
            }}
            dangerouslySetInnerHTML={{
              __html: section.data.quote,
            }}
          />
          {section.data.cite && <BodySmall>{section.data.cite}</BodySmall>}
        </CmsSplitContentBlockquote>
      </Box>
    </Box>
  );
}
